import React, { useRef } from "react";
import {
  HiOutlineArrowsExpand,
  HiOutlineSparkles,
  HiOutlineX,
  HiOutlineRefresh,
} from "react-icons/hi";
import FloatingPopover, {
  FLOATING_POPOVER_MODE,
  FLOATING_POPOVER_PLACEMENT,
  FLOATING_POPOVER_VARIANT,
} from "components/common/FloatingPopover";
import { classNames } from "Utils/utils";
import { VERTEX360_COPILOT_THEME } from "../constants/vertex360CopilotTheme";
import { VERTEX360_COPILOT_DRAWER_Z_INDEX } from "../constants/vertex360CopilotConstants";
import CustomButton from "components/common/Button/CustomButton";

const FULLSCREEN_TOOLTIP = "Open fullscreen view";

const Vertex360CopilotHeader = ({
  onClose,
  onNewChat,
  onOpenFullscreen,
  showNewChat = false,
}) => {
  const fullscreenRef = useRef(null);

  return (
    <header
      className={classNames(
        "relative shrink-0 px-4 py-3",
        VERTEX360_COPILOT_THEME.headerBg
      )}
    >
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#4B6CB7]/40 to-transparent"
        aria-hidden="true"
      />

      <div className="flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <span
            className={classNames(
              "inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-white shadow-lg shadow-[#4B6CB7]/25",
              VERTEX360_COPILOT_THEME.heroGradient
            )}
          >
            <HiOutlineSparkles className="h-5 w-5" />
          </span>
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <h2
                id="vertex360-copilot-drawer-title"
                className="truncate text-[15px] font-bold tracking-tight text-slate-900"
              >
                Vertex360 Copilot
              </h2>
            </div>
            <p className="truncate text-xs text-slate-500">
            Organisation's AI assistant
            </p>
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-1.5">
          {showNewChat ? (
            <CustomButton
              type="button"
              variant="secondary"
              label="New chat"
              Icon={<HiOutlineRefresh className="h-3.5 w-3.5" />}
              clickHandler={onNewChat}
              cssClass="!py-2 !px-2.5 !text-xs !normal-case border-1 border-slate-200 text-[#4B6CB7] hover:border-[#C7D7F5] hover:bg-[#F8FAFF]"
            />
          ) : null}
          {onOpenFullscreen ? (
            <FloatingPopover
              mode={FLOATING_POPOVER_MODE.TOOLTIP}
              variant={FLOATING_POPOVER_VARIANT.BRAND}
              placement={FLOATING_POPOVER_PLACEMENT.LEFT}
              anchorRef={fullscreenRef}
              maxWidth={220}
              offset={8}
              zIndex={VERTEX360_COPILOT_DRAWER_Z_INDEX + 2}
              content={
                <p className="px-2 py-1.5 text-xs font-medium text-slate-700">
                  {FULLSCREEN_TOOLTIP}
                </p>
              }
              contentClassName="!p-0"
            >
              <button
                ref={fullscreenRef}
                type="button"
                onClick={onOpenFullscreen}
                className="rounded-lg p-2 text-slate-500 ring-1 ring-slate-200 transition-colors hover:bg-slate-100 hover:text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
                aria-label={FULLSCREEN_TOOLTIP}
              >
                <HiOutlineArrowsExpand className="h-4 w-4" />
              </button>
            </FloatingPopover>
          ) : null}
          <button
            type="button"
            onClick={onClose}
            className="ring-1 ring-slate-200 rounded-lg p-2 text-slate-400 transition-colors hover:bg-slate-200 bg-slate-100 hover:text-slate-700 text-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
            aria-label="Close Vertex360 Copilot"
          >
            <HiOutlineX className="h-4 w-4" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Vertex360CopilotHeader;
